module.exports = __webpack_public_path__ + "img/drawing05.64ee74fa.png";